import { t } from "./index.js";

// #rotate-overlay (index.html) is pure CSS/HTML with no JS involved in
// showing/hiding it — but its text still needs to track the active
// language, so this tiny imperative hook is called once on boot and again
// every time setLanguage() runs (see appStore.ts), independent of the
// normal Zustand-render-triggered flow the rest of the UI uses.
export function updateRotateOverlayText(): void {
  const el = document.getElementById("rotate-overlay-text");
  if (el) el.textContent = t("rotateOverlay.text");
}
